var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    xmlns: "http://www.w3.org/2000/svg",
    height: 120,
    id: "screenshot-b8a22832-59dd-801c-8008-55b406c8851b",
    viewBox: "0 0 120 120",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-b8a22832-59dd-801c-8008-55b406c8851b"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "frame-clip-b8a22832-59dd-801c-8008-55b406c8851b-render-1",
    className: "frame-clip frame-clip-def"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "frame-container-wrapper",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-blur"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-shadows"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frame-clip-b8a22832-59dd-801c-8008-55b406c8851b-render-1)",
    fill: "none"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-b8a22832-59dd-801c-8008-55b406c8851b"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-b8a22832-59dd-801c-8008-55b406c8851c",
    style: {
      opacity: 1
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-b8a22832-59dd-801c-8008-55b406c8851c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.99993896484375,75.00001525878906L104.99993896484375,95.00001525878906C104.99993896484375,97.65211486816406,103.94622802734375,100.19581604003906,102.07122802734375,102.07106018066406C100.19525146484375,103.94654846191406,97.65228271484375,105.00001525878906,94.99993896484375,105.00001525878906L25,105.00001525878906C22.34765625,105.00001525878906,19.8046875,103.94654846191406,17.9287109375,102.07106018066406C16.0537109375,100.19581604003906,15,97.65211486816406,15,95.00001525878906L15,75.00001525878906",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    id: "strokes-58949171-5f2b-803e-8008-55b418942efc-b8a22832-59dd-801c-8008-55b406c8851c",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.99993896484375,75.00001525878906L104.99993896484375,95.00001525878906C104.99993896484375,97.65211486816406,103.94622802734375,100.19581604003906,102.07122802734375,102.07106018066406C100.19525146484375,103.94654846191406,97.65228271484375,105.00001525878906,94.99993896484375,105.00001525878906L25,105.00001525878906C22.34765625,105.00001525878906,19.8046875,103.94654846191406,17.9287109375,102.07106018066406C16.0537109375,100.19581604003906,15,97.65211486816406,15,95.00001525878906L15,75.00001525878906",
    style: {
      fill: "none",
      strokeWidth: 1.5,
      stroke: "rgb(23, 25, 31)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-b8a22832-59dd-801c-8008-55b406c8851d",
    style: {
      opacity: 1
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-b8a22832-59dd-801c-8008-55b406c8851d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.99993896484375,40L59.99993896484375,15L35,40",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    id: "strokes-58949171-5f2b-803e-8008-55b418959144-b8a22832-59dd-801c-8008-55b406c8851d",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.99993896484375,40L59.99993896484375,15L35,40",
    style: {
      fill: "none",
      strokeWidth: 1.5,
      stroke: "rgb(23, 25, 31)",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-b8a22832-59dd-801c-8008-55b406c8851e",
    style: {
      opacity: 1
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-b8a22832-59dd-801c-8008-55b406c8851e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.99993896484375,15L59.99993896484375,75.00001525878906"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "strokes-58949171-5f2b-803e-8008-55b41896e79f-b8a22832-59dd-801c-8008-55b406c8851e",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.99993896484375,15L59.99993896484375,75.00001525878906",
    style: {
      fill: "none",
      strokeWidth: 1.5,
      stroke: "rgb(23, 25, 31)",
      strokeOpacity: 1,
      strokeLinecap: "round"
    }
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragUpload);
export default __webpack_public_path__ + "static/media/dragUpload.2ed6e6170837c700678527ca4ed09836.svg";
export { ForwardRef as ReactComponent };